import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Actors from "../pages/actors/page";
import ActorDetail from "../pages/actor/page";
import Detail from "../pages/detail/page";
import Reviews from "../pages/reviews/page";
import ReviewDetail from "../pages/review/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/actors",
    element: <Actors />,
  },
  {
    path: "/actor/:id",
    element: <ActorDetail />,
  },
  {
    path: "/detail/:id",
    element: <Detail />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/review/:id",
    element: <ReviewDetail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;